// library imports
import { Button, Col, Flex, Row, Skeleton, Tabs, Select, Divider } from "antd";
// component import
import DeviceCard from "../common/DeviceCard";
import InverterTable from "./InverterTable";
import { LabelValueUnitDisplayRow } from "../../common/WordDisplay";

export default function InverterContent({
  devicePhaseNumberList,
  deviceList,
  pvSystemCard,
  handleChange,
  setOpenModal,
  handleDeviceChange,
  pvSystemLoading,
  pvDeviceLoading,
  deviceSelectionLoading,
  selectedDeviceID,
  systemData,
  pvCardData,
  tableData,
  systemLastUpdate,
  deviceLastUpdate,
  setPhaseNumberSelected,
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          align: "center",
          marginBottom: "12px",
        }}
      >
        <h2 style={{ margin: "0px" }}>PV System</h2>
        <span>Last Update: {systemLastUpdate}</span>
      </div>
      {pvSystemLoading ? (
        <Skeleton active style={{ margin: "5px" }} />
      ) : (
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <LabelValueUnitDisplayRow
              label={"Real Power"}
              value={
                systemData?.realPower !== undefined ? systemData.realPower : "-"
              }
              unit={"kW"}
            />
            <LabelValueUnitDisplayRow
              label={"Reactive Power"}
              value={
                systemData?.reactivePower !== undefined
                  ? systemData.reactivePower
                  : "-"
              }
              unit={"kVAR"}
            />
            <LabelValueUnitDisplayRow
              label={"Apparent Power"}
              value={
                systemData?.apparentPower !== undefined
                  ? systemData.apparentPower
                  : "-"
              }
              unit={"kVA"}
            />
            <LabelValueUnitDisplayRow
              label={"Frequency value"}
              value={
                systemData?.frequency !== undefined ? systemData.frequency : "-"
              }
              unit={"Hz"}
            />
            <LabelValueUnitDisplayRow
              label={"Power Factor"}
              value={
                systemData?.powerFactor !== undefined
                  ? systemData.powerFactor
                  : "-"
              }
              unit={""}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <LabelValueUnitDisplayRow
              label={"Energy Generation (Peak) - Month"}
              value={
                systemData?.onPeakGeneration !== undefined
                  ? systemData.onPeakGeneration
                  : "-"
              }
              unit={"kWh"}
            />
            <LabelValueUnitDisplayRow
              label={"Energy Generation (Off-Peak) - Month"}
              value={
                systemData?.offPeakGeneration !== undefined
                  ? systemData.offPeakGeneration
                  : "-"
              }
              unit={"kWh"}
            />
            <LabelValueUnitDisplayRow
              label={"Energy Generation - Month"}
              value={
                systemData?.energyGeneration !== undefined
                  ? systemData.energyGeneration
                  : "-"
              }
              unit={"kWh"}
            />
            <LabelValueUnitDisplayRow
              label={"Reactive Energy Generation - Month"}
              value={
                systemData?.reactiveEnergyGeneration !== undefined
                  ? systemData.reactiveEnergyGeneration
                  : "-"
              }
              unit={"kVARh"}
            />
          </Col>
        </Row>
      )}

      <div>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            align: "center",
          }}
        >
          <h2 style={{ margin: "0px" }}>PV Inverter Main Parameters</h2>
          <span>Last Update: {deviceLastUpdate}</span>
        </div>
        {/* <Tabs
          items={devicePhaseNumberList}
          onChange={(key) => setPhaseNumberSelected(key)}
        /> */}
        <Flex justify="space-between" align="center" className="mt-3 mb-3">
          {deviceList.length > 0 && selectedDeviceID ? (
            <>
              <Select
                loading={deviceSelectionLoading}
                onChange={(value) => handleDeviceChange(value)}
                value={selectedDeviceID}
                options={deviceList}
                style={{ width: "100%", marginRight: "8px" }}
              />
              <Flex gap={"8px"}>
                <Button
                  disabled={pvCardData.length === 0 || pvDeviceLoading}
                  onClick={() => setOpenModal(true)}
                >
                  View Device Details
                </Button>
                <Button onClick={handleChange}>Change View</Button>
              </Flex>
            </>
          ) : (
            <></>
          )}
        </Flex>
        {pvDeviceLoading ? (
          <Skeleton active style={{ margin: "5px" }} />
        ) : pvSystemCard == true ? (
          <Col span={24}>
            <Row gutter={[18, 18]}>
              {tableData?.map((d, index) => {
                const key = `col-${index}`;
                return (
                  <Col
                    key={key}
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 8 }}
                    xxl={{ span: 6 }}
                  >
                    <DeviceCard data={d} setOpenModal={setOpenModal} />
                  </Col>
                );
              })}
            </Row>
          </Col>
        ) : (
          <InverterTable data={tableData} />
        )}
      </div>
    </div>
  );
}
